import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0d665f3e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=0d665f3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d665f3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d665f3e')) {
      api.createRecord('0d665f3e', component.options)
    } else {
      api.reload('0d665f3e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0d665f3e&scoped=true&", function () {
      api.rerender('0d665f3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/settings/profile/index.vue"
export default component.exports